<router-outlet></router-outlet>
<p-confirmDialog key="idle-confirm" header="Confirmation" icon="pi pi-exclamation-triangle" [style]="{width: '50vw'}"></p-confirmDialog>